<template>
	<!-- 修改密码 -->
	<div class="aboutYjBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">修改密码</p>
				</div>
			</div>
		</van-sticky>
		<div class="xgpasswordBox">
			<img src="../../assets/img/xgpasswordIcon.png" alt=""/>
			<p>为了您的账户安全，需要验证您的手机</p>
			<p>{{mobile}}</p>
		</div>
		<div class="getYzmBox">
			<span>验证码</span>
			<input type="number" placeholder="请输入验证码" v-model="codeTxt">
			<span class="pink_txt" @click="send_codeFn"><i>|</i>获取验证码</span>
		</div>
		<div @click="bcpasswordFn" class="btn">
			<img src="../../assets/img/flower.png" alt="" class="flower">
			<button>下一步</button>
		</div>
	</div>
</template>

<script>
	import {Toast} from 'vant';
	export default {
		data() {
			return {
				mobile: '',
				codeTxt:'',
			}
		},
		created() {
			var reg = /^(\d{3})\d{4}(\d{4})$/;
			this.mobile = JSON.parse(localStorage.getItem('userInfoData')).mobile.replace(reg, "$1*****$2");
		},
		methods: {
			back() {
				this.$router.push('/set')
			},
			// 发送手机验证码
			send_codeFn(){
				this.$axios.post(this.$api.send_code,{
					mobile: JSON.parse(localStorage.getItem('userInfoData')).mobile,
					type:2
				}).then(res =>{
					Toast(res.data.msg)
				})
			},
			// 获取手机验证码
			reset_code_check(){
				this.$axios.post(this.$api.reset_code_check,{
					code: this.codeTxt
				}).then(res =>{
					Toast(res.data.msg)
				})
			},
			bcpasswordFn(){
				if(this.codeTxt != ''){
					this.$router.push({path:'/bcpassword'})
				}else{
					this.reset_code_check();
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.aboutYjBox{
		background-color: #fff;
		height: 100vh;
		overflow-y: scroll;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88%;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
		
				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}
		
				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}
		
		}
		.xgpasswordBox{
			text-align: center;
			margin-top: 50px;
			img{
				height: 166px;
				margin-bottom: 40px;
				vertical-align: middle;
			}
			p{
				line-height: 60px;
				font-size: 30px;/*px*/
			}
		}
		.getYzmBox{
			margin-top: 100px;
			padding: 0 20px;
			display: flex;
			justify-content: space-between;
			font-size: 30px;/*px*/
			span{
				display: inline-block;
				padding:10px 20px;
				padding-left:0;
				i{
					color: #f0f0f0;
					padding-right: 20px;
					font-style: normal;
					
				}
			}
			.pink_txt{
				color: #ff5790;
				padding-right: 0;
			}
			input{
				width: 50%;
			}
			input::placeholder{
				font-size: 24px;/*px*/
			}
		}
		.btn{
			text-align: center;
			margin-top: 180px;
			position: relative;
			.flower{
				position: absolute;
				top: -60px;
				left: 20%;
				width: 100px;
			}
			button{
				border: 0;
				line-height: 80px;
				font-size: 32px;/*px*/
				width: 90%;
				background-color: #FF4081;
				color:#fff;
				border-radius: 10px;
			}
		}
	}

</style>
